//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CobranzaApi from "@/api/promotores/cobranzas.api";
import moment from 'moment'

export default {
  props: {
    cobranzaId: String,
  },
  data() {
    return {
      loading: false,
      cobranza: {
        visitas: [],
        formulario: {}
      },
      tab: "cobranza",
    };
  },

  methods: {
    show() {
      this.loadCobranza()
      this.$refs.dialog.show();
    },

    hide() {
      this.$refs.dialog.hide();
    },

    async loadCobranza() {
      this.cobranza = await CobranzaApi.get(this.cobranzaId)
    },

    async submit() {
      this.loading = true;
      await CobranzaApi.update(this.cobranza._id, this.cobranza);
      this.loading = false;
      this.$emit("ok", this.localCobranza);
      this.hide();
    },
  },

  filters: {
    date(value) {
      return moment(value).format('DD/MM/YYYY')
    }
  }
};
